import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { queryGetAgents } from "Apollo";
import Picker from "module-common/Picker";
import { CommonStore } from "Store";

export default graphql(queryGetAgents)(
  class PickerAgent extends Component {
    static propTypes = {
      showAllAgents: PropTypes.bool,
      onSelected: PropTypes.func,
      selectedList: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number
        })
      )
    };

    render() {
      const agents = this.props.data.getAgents;
      const { showAllAgents, selectedList, ...rest } = this.props;
      const options = [];
      const agentMe = CommonStore.me.agent;

      if (agents) {
        for (const agent of agents) {
          if (agent.id !== agentMe.id) {
            let isSelected = false
            if(selectedList) {
              isSelected = selectedList.find(elm => elm.id == agent.id)
            }
            options.push({ label: agent.displayName, value: agent, selected: isSelected });
          }
        }
        if (showAllAgents) {
          let isSelected = false
          if(selectedList) {
            isSelected = selectedList.find(elm => elm.id == agentMe.id)
          }
          options.push({ label: agentMe.displayName, value: agentMe, selected: isSelected });
          options.push({ label: "All Agents", value: null });
        }
      }

      return (
        <Picker {...rest} options={options}>
          {this.props.children}
        </Picker>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-common/PickerAgentWithQuery.js